import Entity from './entity';
export default Entity.extend({
  precedence: 2,
  type: 'bold',
  tagName: 'b',
  attributesToCopy: ['startIndex', 'endIndex'],
  options: {}
}).reopenClass({
  tagName: 'B'
});